interface VimeoProps {
  size?: number;
}

const Vimeo = (props: VimeoProps) => {
  const { size = 30 } = props;
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M23.977 6.416c-.105 2.338-1.74 5.545-4.905 9.622-3.275 4.257-6.045 6.386-8.308 6.386-1.402 0-2.587-1.296-3.555-3.887-.645-2.368-1.291-4.737-1.936-7.105-.718-2.59-1.489-3.886-2.314-3.886-.18 0-.81.378-1.889 1.134L0 7.219C1.187 6.175 2.357 5.131 3.51 4.087 5.098 2.684 6.288 1.943 7.082 1.866c1.871-.18 3.023 1.101 3.456 3.843.467 2.957.79 4.797.97 5.518.539 2.455 1.132 3.682 1.78 3.682.503 0 1.26-.794 2.27-2.381 1.007-1.588 1.546-2.794 1.615-3.619.144-1.367-.394-2.051-1.615-2.051-.575 0-1.168.131-1.78.394 1.182-3.873 3.439-5.754 6.772-5.646 2.47.072 3.63 1.671 3.477 4.81z"
      />
    </svg>
  );
};

export default Vimeo;
